
import PropTypes from 'prop-types';
import { Box, Button, ListItem } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

export const NavItem = (props) => {
    const { href, icon, title, ...others } = props;
    let location = useLocation();
    const active = href ? (location.pathname === href) : false;

    return (
        <ListItem
            disableGutters
            sx={{
                display: 'flex',
                mb: 0.5,
                py: 0,
                px: 2
            }}
            {...others}
        >
            <Button
                component={Link}
                to={{
                    pathname: href,
                }}
                startIcon={icon}
                sx={{
                    backgroundColor: active && 'rgba(255,255,255, 0.08)',
                    borderRadius: 1,
                    color: active ? 'special.green' : "#F3F4F6",
                    fontWeight: active && 'fontWeightBold',
                    justifyContent: 'flex-start',
                    px: 2,
                    textAlign: 'left',
                    textTransform: 'none',
                    width: '100%',
                    '& .MuiButton-startIcon': {
                        color: active ? 'special.green' : "#F3F4F6"
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(255,255,255, 0.08)'
                    }
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    {title}
                </Box>
            </Button>
        </ListItem>
    );
};

NavItem.propTypes = {
    href: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.string
};
